export default function (data, id) {
  const getStatus = (value) => {
    let status, text;
    switch (value) {
      case -1:
        status = 'muted';
        text = 'In Process';
        break;
      case 1:
        status = 'warning';
        text = 'Last submission Success'; //'Not updated';
        break;
      case 2:
        status = 'success';
        text = 'Last submission Success';
        break;
      case 3:
        status = 'danger';
        text = 'Last submission Failed';
        break;
      default:
        status = 'muted';
        text = 'Unknown';
    }
    return {
      status,
      text
    };
  };

  const createDate = data.createDate ? moment(data.createDate).format('MMM DD, YYYY, HH:mm') : '';
  const lastSuccessCreateDate = data.lastSuccessCreateDate
    ? ', ' + moment(data.lastSuccessCreateDate).format('MMM DD, YYYY, HH:mm')
    : '';

  let statusLog = '';
  if (data.status === -1) {
    statusLog = `<p class="js-action-folderdialog align-items-center mb-3 mt-n2 text-muted" data-action="logfolder" data-directory="${
      data.directoryName
    }_log" data-id="${id}">
                  <i class="fal fa-spinner fa-pulse mr-2"></i>${data.directoryName}${
      data.directoryName !== 'BOM' ? ' rip files' : ''
    } submission in Process
                 </p>`;
  } else if (data.lastSuccessStatus) {
    statusLog = `<p class="js-action-folderdialog align-items-center mb-3 mt-n2 text-muted" data-action="logfolder" data-directory="${
      data.directoryName
    }_log" data-id="${id}">
                    <i class="fas fa-exclamation-triangle fa-fw mr-2"></i> 
                    ${getStatus(data.lastSuccessStatus).text + lastSuccessCreateDate}
                    ${
                      data.correlationId && data.lastSuccessStatus !== 1
                        ? `<span class="pl-3"><i class="js-action-folder-link fal fa-question-circle fa-lg text-primary"></i></span>`
                        : ``
                    }
                 </p>`;
  } else if (data.status === 3) {
    statusLog = `<p class="js-action-folderdialog align-items-center mb-3 mt-n2 text-muted" data-action="logfolder" data-directory="${
      data.directoryName
    }_log" data-id="${id}">
                    <i class="fas fa-exclamation-triangle fa-fw mr-2"></i> 
                    ${getStatus(data.status).text + (createDate ? ', ' : '') + createDate}
                    ${
      data.statusMessage
        ? `<span class="pl-3"><i class="js-action-folder-error fal fa-question-circle fa-lg text-primary"></i></span>`
        : ``
    }
                 </p>`;
  }

  const errorMessageBlock =
    data.status === -1 && !!data.statusMessage
      ? `<p class="align-items-center mb-3 mt-n2 text-muted">${data.statusMessage}</p>`
      : '';

  return `<p class="js-action-folderdialog align-items-center mb-3" data-directory="${
    data.directoryName
  }" data-id="${id}">
            <span class="status-label mr-n4">${
              createDate && data.correlationId && data.status !== -1
                ? `<i class="js-action-folder-link fal fa-folder-open fa-lg mr-1 text-primary"></i>`
                : `<i class="fal fa-folder-open fa-lg mr-1 text-muted"></i>`
            }
              <b class="text-${getStatus(data.status).status}">${data.directoryName}</b>
            </span>
            ${createDate && `<span class="d-inline-flex text-nowrap ml-4 pl-2">${createDate}</span>`}
          </p>
          ${statusLog}${errorMessageBlock}`;
}
